<template>
  <Category
    cate-name="top5"
    category-name="総合大賞"
    category-intro="今年もっとも輝いたメルマガを決定する「まぐまぐ大賞」。 2020年度「いちばん読みたい・読んでもらいたいメルマガ」に輝いた総合大賞5誌を発表いたします。"
  />
</template>

<script>
import Category from '@/components/Category.vue'
export default {
  components: {
    Category
  }
}
</script>

<style scoped></style>
